let baseURL;
let base;

if (process.env.NODE_ENV === "production") {
  baseURL = "https://paulinesafrica.org/api/v1";
  base = "https://paulinesafrica.org/";
} 
else {
  baseURL = "http://127.0.0.1:8000/api/v1";
  base = "http://127.0.0.1:8000/";
}

const config = {
  baseURL,
  base,
};

export default config;
